import React from 'react'

// Components
import InteractiveButton from '../InteractiveButton/InteractiveButton';
import Tooltip from '../Tooltip';

// Hooks
import useEditModeEnabled from '../../hooks/useEditModeEnabled';

export type CycleAction = {
  name: string;
  icon: JSX.Element;
  onClick: () => void;
}

type ComponentProps = {
  actions: CycleAction[];
  className?: string;
}

const CycleActions: React.FC<ComponentProps> = ({ actions, className = '' }) => {
  const isEditModeEnabled = useEditModeEnabled();

  return (
    <div className={`c-cycle-actions grid grid-flow-col auto-cols-[40px] gird gap-x-3 ${className}`}>
      {actions.map((action, index) => (
        <InteractiveButton
          onClick={action.onClick}
          disabled={!isEditModeEnabled}
          key={`action-${index}-${action.name}`}
          customType='min-w-fit min-h-fit border border-foggy-mist rounded active:border-primary cursor-pointer'
          style={{ padding: '0px' }}
        >
          <Tooltip hint={action.name}>{action.icon}</Tooltip>
        </InteractiveButton>
      ))}
    </div>
  )
};

export default CycleActions;